(function ($) {
    rter.mapController('app.tire.pricing.model', function (context) {
        var grid = null;
        var filters = {};
        var $filterForm, $filterButton;

        return {
            viewWillLoad: function (ctx) {
                filters = $.extend(filters, ctx.state ? context.state['filters'] : {});
            },
            viewCreated: function ($outlet) {
                grid =
                    datagrid.create({
                        container: $outlet.find('div.data-wrapper'),
                        allowShowAll: true,

                        headerActions: [
                            rstools.shared.datagrid.headerActions.manageColumns
                        ],
                        getColumnSettings: rstools.shared.datagrid.retrieveColumnSettings,
                        
                        fields: [
                            { name: 'TireBrandName', caption: 'Brand' },
                            { name: 'TireModelName', caption: 'Model' },
                            {
                                name: 'Sidewalls',
                                caption: 'Sidewalls',
                                format: function (r) {
                                    return $.map(r.Sidewalls, function (sidewall) {
                                        return sidewall.TireSidewallName;
                                    }).join(', ');
                                },
                                sort: false
                            },
                            {
                                name: '!Price',
                                caption: 'Price',
                                format: function (r) {
                                    return rstools.pricing.format.prices(rstools.pricing.utils.getBestPricingType(r.Pricing));
                                }
                            },
                            {
                                name: 'TireModelNotes',
                                caption: 'Notes',
                                colClass: 'text-center',
                                sort: false,
                                columnRenderer: rstools.notes.createColumnRenderer('tire.model'),
                                requiredRoles: [rstools.roles.SYSTEM_ADMIN],
                                visible: false
                            },
                            { name: 'actions', caption: '', width: '100px', sort: false }
                        ],

                        actions: [
                            {
                                title: 'View Fitments',
                                id: 'list',
                                icon: 'fa fa-th-list',
                                multiple: true,
                                fields: ['actions'],
                                callback: function (rows) {
                                    rter.routes.go('/app/tire/pricing/fitment', {
                                        filters: {
                                            PricingGroupID: filters.PricingGroupID,
                                            TireModels: $.map(rows, function (row) {
                                                return row.TireModelID;
                                            })
                                        }
                                    });
                                }
                            }
                        ],

                        getAction: 'Tire/GetModelDescriptions',
                        countAction: 'Tire/CountModelDescriptions',
                        resultListField: 'Models',
                        baseQueryData: {
                            SelectBrandsOnly: false,
                            IncludePricing: true,
                            HasPricing: true
                        },

                        search: filters,
                        namespace: 'tire-model',
                        rowSelect: function (model) {
                            grid.action.getByID('list').callback([model]);
                        }
                    });
                
                $filterForm = rstools.pricing.utils.createFilterForm(context, {
                    onReset: filtersUpdated,
                    onSubmit: filtersUpdated,
                    filters: filters
                });

                var $leftButtons = $('<div/>', { 'class': 'left-buttons' }).prependTo(grid.topControls);

                $filterButton = uifactory.create.filterButton({
                    menu: $filterForm
                })
                    .appendTo($leftButtons)
                    .trigger('filters-updated', [Object.keys(filters).length]);
            },
            viewLoaded: function (ctx) {
                $filterForm.syncObjectToForm(filters);
            }
        };

        function filtersUpdated() {
            $filterForm.syncFormToObject(filters);
            $filterButton.trigger('filters-updated', [Object.keys(filters).length]);

            grid.search(filters);
            rstools.state.set('filters', filters);
        }
    });
})(jQuery);